import transformToReferenceValue from 'rlink-data-connector/storage/transformToReferenceValue';

/**
 * For the given embeddedValue returns an object keyed by the reference key
 * of each embedded value contained within, whose values are triplets of:
 *
 *   1. the reference object for the embedded value
 *   2. the embedded value transformed into a reference value (i.e. all embedded values within it are replaced by references)
 *   3. the embedded value's meta object (i.e. special storage directives)
 *
 *
 * There are also callbacks called with the embedded value before it
 * is transformed and also when emebeds are replaced with references
 * in their parent.
 *
 * @param  {EmbeddedValue} embeddedValue
 * @param  {Object<Function>} callbacks
 * @return {Object<refString: [Reference, ReferenceValue, meta]>}
 */
export default function _referencesAndReferenceValues (embeddedValue, {onInnerEmbeddedValue = () => null, onBeginProcessing = () => null}) {
  onBeginProcessing(embeddedValue);
  let referencesAndValues = {};
  let referenceValue = transformToReferenceValue(
    embeddedValue.storagePayload,
    embedded => {
      Object.assign(referencesAndValues,
        _referencesAndReferenceValues(embedded, {onInnerEmbeddedValue, onBeginProcessing}));
      onInnerEmbeddedValue(embeddedValue, embedded);
      return embedded.reference;
    }
  );
  referencesAndValues[embeddedValue.reference] = [
    embeddedValue.reference,
    referenceValue,
    embeddedValue.meta,
  ];
  return referencesAndValues;
}



// WEBPACK FOOTER //
// ./lib/rlink-data-connector/storage/_referencesAndReferenceValues.js